import { Injectable } from '@angular/core';
import { interval, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CounterService {
  constructor() {}

  /**
   * Animate a number from 0 to target
   * @param target final number
   * @param duration total animation duration in ms
   * @param step optional callback for each step
   */
  countTo(target: number, duration = 2000, step: (value: number) => void): void {
    const fps = 60; // frames per second
    const totalSteps = Math.ceil((duration / 1000) * fps);
    let currentStep = 0;

    const increment = target / totalSteps;

    const stop$ = new Subject<void>();

    interval(1000 / fps)
      .pipe(takeUntil(stop$))
      .subscribe(() => {
        currentStep++;
        const value = Math.min(Math.ceil(currentStep * increment), target);
        step(value);

        if (currentStep >= totalSteps) stop$.next();
      });
  }
}
